import React from 'react'

import { connect } from 'react-redux'
import { mapLanguageToComponentProps } from 'i18n'
import { Notification } from 'components/styled/modal/notification'
import { Body, Subtitle } from 'components/styled/typography'
import { I18nComponentType } from 'i18n-types'
import { AlertVariant } from 'components/styled/alert/context'
import { StyledTheme } from 'theme'

type ModalSize = keyof StyledTheme['modal']

export interface ConfirmationProps {
  i18n?: I18nComponentType
  dispatch?: any
  id?: string
  isOpen?: boolean
  onConfirm?: () => void
  onCancel?: () => void
  alertIcon?: AlertVariant
  isLoading?: boolean
  title?: string
  body?: string | React.ReactNode
  primaryButtonText?: string
  primaryButtonIcon?: string
  size?: ModalSize
  useConfirm?: boolean
  flippedView?: boolean
}

export const ConfirmationFC = ({
  i18n,
  id,
  isOpen,
  alertIcon = 'warn',
  title,
  body,
  size = 'small',
  onConfirm,
  onCancel,
  isLoading,
  primaryButtonText,
  primaryButtonIcon,
  useConfirm,
  flippedView,
  dispatch,
  ...props
}: ConfirmationProps) => {
  return (
    <Notification
      hasOverlay
      id={id}
      isOpen={isOpen}
      size={size}
      alertIcon={alertIcon}
      onClose={onCancel}
      flippedView={flippedView}
      {...props}
      secondaryButton={{
        text: i18n.modalConfirm.cancel,
        disabled: isLoading,
      }}
      primaryButton={{
        text: primaryButtonText || i18n.modalConfirm.confirm,
        onClick: () => onConfirm(),
        loading: isLoading,
        useConfirm,
        flippedIcon: primaryButtonIcon ? flippedView : false,
        icon: primaryButtonIcon || 'check',
      }}
    >
      {title && <Subtitle fontWeight={600}>{title}</Subtitle>}
      {body && (
        <Body color="grey90" whiteSpace="pre-line">
          {body}
        </Body>
      )}
    </Notification>
  )
}

export const Confirmation = connect<{ i18n: I18nComponentType }>(
  mapLanguageToComponentProps()
)(ConfirmationFC)
